<svelte:options accessors/>
<script>
    import {createEventDispatcher} from "svelte";
    import {getFormatter, getSubtotal, getTotal} from "../../../utils";
    import NauiExplorer from "../../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiTag from "../../../naui/atoms/NauiTag.svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiTable from "../../../naui/components/NauiTable.svelte";

    export let data;
    export let columns;

    let open = false;
    let dispatch = createEventDispatcher();
    let formatter = getFormatter();

    let enabledColumns = [
        {
            slug: 'name',
            label: 'Materiales',
            type: 'text',
            order: false
        },
        {
            slug: 'quantity',
            label: 'Cantidad',
            type: 'text',
            order: false
        },
        {
            slug: 'value',
            label: 'Valor',
            type: 'text',
            order: false
        },
        {
            slug: 'actions',
            label: '',
            type: 'actions',
            order: false
        }
    ];

    $: enabled = data ? data.filter(d => d.quantity > 0) : [];
    $: subtotal = getSubtotal(enabled);
    $: total = getTotal(enabled);

    $: labelSubtotal = `Subtotal sin IVA | ${formatter(subtotal)}`;
    $: labelTotal = `Subtotal con IVA | ${formatter(total)}`;

    $: summaryData = setSummary(data);

    function showImages() {
    }

    function setSummary(d) {
        const summary = [];
        if (d) {
            for (const item of d) {
                if (item.quantity > 0) {
                    summary.push({
                        ref: item,
                        slug: item.slug,
                        name: item.name,
                        quantity: item.quantity,
                        value: formatter(item.quantity * item.price),
                        actions: item.actions
                    });
                }
            }
        }
        return summary;
    }

    function removeItem(ev) {
        ev.detail.item.ref.quantity = 0;
        data = data;
    }

    function save() {
        dispatch('save', {data});
    }

    function changeData(ev) {
        const item = ev.detail.item;
        item.quantity = ev.detail.data;
        data = data;
    }
</script>

<div>
    <NauiExplorer {data} {columns} hideSearch={true} paginate={false} on:action={(ev) => changeData(ev)}>
        <div slot="actions">
            <div class="box-l sx-15">
                <div class="grid grid-4 gap-ii">
                    <NauiButton on:click={() => open = true} caption="AGREGAR A LA COTIZACIÓN" mode="stroked"
                                icon="plus"/>
                    <NauiButton on:click={showImages} caption="VER IMAGES DEL SERVICIO" icon="image" mode="accent"/>
                    <NauiTag label={labelSubtotal}/>
                    <NauiTag label={labelTotal}/>
                </div>
            </div>
        </div>
    </NauiExplorer>
    <div class="p-1">
        <NauiButton on:click={() => open = true} caption="AGREGAR A LA COTIZACIÓN" mode="stroked" icon="plus"/>
    </div>
</div>

<NauiSlideOver bind:open={open} title="TOTAL VITRINA">
    <NauiTable data={summaryData} columns={enabledColumns} on:action={removeItem}/>
    <div class="py-15">
        <h2 class="accent text-c w-100">{labelSubtotal}</h2>
        <h2 class="accent text-c w-100">{labelTotal}</h2>
    </div>
    <NauiButton on:click={save}
                color="accent"
                mode="solid"
                caption="AGREGAR A LA COTIZACIÓN"/>
</NauiSlideOver>